import {createActions} from '../../../baseClasses/ActionFactory';

const {types: generalTypes, actions: generalActions} = createActions({store: 'FIELD_TOOLS'});
const allActions = {...generalActions};
const allTypes = {...generalTypes};

export {allTypes as types, allActions as actions};
